import { render, staticRenderFns } from "./BorderWidth.vue?vue&type=template&id=8c3f9c2a&"
import script from "./BorderWidth.vue?vue&type=script&lang=js&"
export * from "./BorderWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports